module.exports = __webpack_public_path__ + "img/MAC.b481e879.png";